function AccreditationController(){
	this.className	= "AccreditationController";
	this.glob		= ["/accreditation**","/admin**","/hub**"];
	this.debug		= false;
};
AccreditationController.inheritsFrom( StandardController );
AccreditationController.prototype.swap = function(){
	this.$body				= $("body").find(".js-body");
	this.$page 				= this.$body.find(".js-page");
	this.$popup 			= $("body").find(".js-page-popup");
	this.$progress 			= this.$page.find(".js-accreditation-progress");
	this.$mainHeader 		= this.$page.find('.js-accreditation-header');
	this.$crieria 			= this.$page.find('.js-accredtiation-criteria');
	this.$approvalButton    = this.$page.find('.js-admin-approval');
	this.$cancelButton      = this.$page.find('.js-admin-cancel');
	this.$unlockButton      = this.$page.find('.js-admin-unlock');

	// Variables
	this.requiresCacheClearing = false;
	this.level 				   = 1;
	this.progress			   = 0;
	this.circumference         = 314;
	this.previousProgress	   = 0;
	this.currentProgress       = 0;
	this.isAdmin   			   = false;
	this.isDisabled   		   = false;
	this.isApproved   		   = null;
	this.isUnapproved   	   = false;
	this.isPending   		   = false;
	this.isReadonly   		   = true;
	this.requireUpdate   	   = false;
	this.progressSpeed 		   = this.$progress.attr('data-speed') || 20;

	this.meta   = this.getMeta();
	this.status = this.meta?.submission?.status;
	this.criteriaTotal = this.meta?.progress?.mandatory_total || 0;
	this.criteriaComplete = this.meta?.progress?.mandatory_completed || 0;

	// Templates
	this.templates = this.loadTemplates(['submit','pending','unapproved','approved','cancelled','badge-approved']);
	if(this.$mainHeader.length) this.defaultTemplate = Handlebars.compile(this.$mainHeader.html());

	// Setup DOM / Events
	this.setup();

	// Setup categories
	this.setupCategories();

	// if (this.apt) this.apt.destroy();
	this.apt = new AcceleratePositionToggle({
		a: this.progressSpeed,
		x: 0,
		onChange: (x, b) => {
			let progress = x;
			this.progress = progress;
			this.renderProgress(progress);
		},
		onComplete: (x, b) => {
			this.$progressGlow.toggleClass('colour-secondary', !!this.isComplete);
		}
	});

	// Check current accreditation status
	this.checkAccreditation();
};

/**
 * Setup DOM / Events
 *
 */
AccreditationController.prototype.setup = function() {
	this.$mainContent 		= this.$mainHeader.find('.js-accreditation-content');
	this.$submitResults		= this.$mainHeader.find(".js-submit-results");
	this.$editResults       = this.$mainHeader.find('.js-edit-results');
	this.$progress			= this.$page.find(".js-accreditation-progress");
	this.$progressPercentage= this.$progress.find(".js-progress-percentage");
	this.$progressLabel 	= this.$progressPercentage.find('.label');
	this.$progressRing		= this.$progress.find(".js-progress-ring");
	this.$progressGlow		= this.$progress.find(".js-progress-glow");

	this.isMakingChanges = false;

	this.currentURI = `${nav.sliceUrl(nav.getUrl(),this.level)}`;
	this.isAdmin    = ('admin' === nav.getState().nextParts[0] && nav.getState().nextParams.licensee);

	// this.updateAdminButtons();

	// Progress ring stroke dasharray ready for late.
	this.$progressRing.css({
		strokeDasharray: `${this.circumference}% ${this.circumference}%`,
	});

	// Submit results click event
	if(this.$submitResults) {
		this.$submitResults.off().on('click', (e) => {
			e.preventDefault();
			const $button = $(e.currentTarget);
			return this.submitData(
				`${this.currentURI}submitResults`, {},
				{
					$button: $button,
					onComplete: (results, success) => {
						if (success) {
							const $statusPending = this.$mainContent.find('.js-accreditation-status');
							$statusPending.text($statusPending.attr('data-status-pending'));
							this.status = 'pending';
							this.checkAccreditation();
						}
					}
				}
			);
		});
	}

	// Approve accreditation click event
	if (this.$approvalButton) {
		this.$approvalButton.off().on('click', (e) => {
			e.preventDefault();
			const $button = $(e.currentTarget);
			const approvalStatus = $button.attr('data-status');

			let data = {
				status: approvalStatus,
			};

			if ($button[0].classList.contains('disabled')) {
				return;
			}

			return this.submitData(
				`${this.currentURI}updateAccreditation?licensee=${nav.getState().nextParams.licensee}`,
				data,
				{
					$button: $button,
					submitting: true,
					onComplete: (results, success, e) => {
						if (success) {
							this.status = approvalStatus;
							if ($button.hasClass('js-approval-cancel')) {
								this.blockSubmitting = true;
							}
							this.updateAdminButtons();
						}
						// $button.toggleClass('colour-secondary', !!success);
					}
				}
			);
		});
	}

	// Reaccredit click event
	if (this.$editResults) {
		this.$editResults.off().on('click', (e) => {
			e.preventDefault();
			const $button = $(e.currentTarget);

			const pendingContent = 'You will need to resubmit your application after making changes. Are you sure you want to continue?';
			const approvedContent = 'You will need to resubmit your application after making changes. This process can\'t be cancelled. Are you sure you want to continue?';

			this.editResultsPopup = new ConfirmationPopup({
				controller: this,
				$overlay: $('.js-dialog-popup'),
				values: {
					title:   'Are you sure you want to continue making changes?',
					content: this.isApproved ? approvedContent : pendingContent,
					buttons: [
						{ link: '#yes', label: 'Make changes', class: 'js-button-yes' },
						{ link: '#no', label: 'Cancel', class: 'js-button-no' }
					],
					onCallback: (response, popup) => {
						if (response) {
							this.isMakingChanges = true;
							this.resetAccreditation();
							popup.cancel();
						} else {
							this.isMakingChanges = false;
							popup.cancel();
						}
					}
				},
			});
		});
	}
}

/**
 * Check accreditation status
 *
 */
AccreditationController.prototype.resetAccreditation = function() {
	const licenseeHash = nav.getState().nextParams.licensee;

	let queryString = '';
	if(licenseeHash) queryString = `?licensee=${licenseeHash}`;

	this.status = 'unapproved'; //this.isPending ? 'pending' : 'unapproved';

	return this.submitData(
		`${this.currentURI}updateAccreditation${queryString}`,
		{
			completed: this.criteriaComplete,
			status: this.status,
		},
		{
			onComplete: (results, success, e) => {
				this.checkAccreditation();
			}
		}
	);
}

/**
 * Check accreditation status
 *
 */
AccreditationController.prototype.checkAccreditation = function() {
	switch (this.status) {
		case 'approved':
			this.isDisabled = false;
			this.isApproved = true;
			this.isPending  = false;
			break;
		case 'unapproved':
			this.isDisabled = false;
			this.isApproved = false;
			this.isPending  = false;
			break;
		case 'pending':
			this.isDisabled = false;
			this.isApproved = null;
			this.isPending  = true;
			break;
		case 'disabled':
			this.isDisabled = true;
			this.isApproved = null;
			this.isPending  = false;
			break;
		default:
			this.isDisabled = false;
			this.isApproved = null;
			this.isPending  = false;
	}

	console.log(
		'status', this.status,
		'locked?', this.isDisabled,
		'Approved?', this.isApproved,
		'Pending?', this.isPending
	);

	this.maybeMakeReadonly();
	this.updateAdminButtons();
	this.checkProgress();
}

/**
 * Make content read only.
 *
 */
AccreditationController.prototype.updateAdminButtons = function(status=false) {
	if (!this.isAdmin) return;
	if (!status) status = this.status;

	// Loop buttons
	if (this.$approvalButton.length) {
		this.$approvalButton.each((index, e) => {
			const $this = $(e);

			//setTimeout( () => {
				this.$crieria.toggle('disabled' !== this.status);

				const conditions = $this.attr('data-condition')?.split(',');
				if (conditions) {
					if (conditions.indexOf(status) > -1) {
						$this.removeClass('disabled').attr('disabled', false);
						$this.text($this.attr('data-default'));
					} else {
						$this.addClass('disabled').attr('disabled', true);
					}
				}

				if (e.classList.contains('js-admin-cancel')) {
					if ('disabled' === status) {
						$this.attr('data-status', 'unapproved');
						$this.attr('data-submitted', 'Enable');
						$this.text('Enable');
						this.$approvalButton.not('.js-admin-cancel').hide();
					} else {
						$this.attr('data-status', 'disabled');
						$this.attr('data-submitted', 'Disable');
						$this.text('Disable');
						this.$approvalButton.not('.js-admin-cancel').show();
					}
				}
			//}, 200);

		});
	}
}

/**
 * Make content read only.
 *
 */
AccreditationController.prototype.maybeMakeReadonly = function() {
	this.isReadonly = (this.isDisabled || this.isPending || this.isApproved);
	if (this.isAdmin) {
		this.isReadonly = false;
	}
}

/**
 * Setup categories & criteria
 *
 * @param criteriaId
 * @param data
 */
AccreditationController.prototype.setupCategories = function(criteriaId, data = {}) {
	const $categories = this.$page.find(".js-category");
	if (!$categories.length) return;

	const categories	= [];
	const criteria		= [];
	this.categories		= categories;
	this.criteria		= criteria;

	// Page setup
	$categories.each((i,elm) => {

		const cat = {};
		cat.$wrapper 	= $(elm);
		cat.itemId 		= parseInt(cat.$wrapper.attr("data-category-id"))

		cat.$criteria 	= cat.$wrapper.find(".js-criterion");
		cat.$markers 	= cat.$wrapper.find(".js-markers");
		cat.$count		= cat.$wrapper.find(".js-count");
		cat.$total 		= cat.$wrapper.find(".js-total");
		cat.$countBonus	= cat.$wrapper.find(".js-count-bonus");
		cat.$totalBonus	= cat.$wrapper.find(".js-total-bonus");
		cat.$bonusItems	= cat.$wrapper.find(".js-bonus-element");

		cat.criteria 		= [];
		cat.count 			= 0;
		cat.requiredCount 	= 0;
		cat.bonusCount 		= 0;
		cat.complete 		= false;

		cat.$criteria.each( (i, elm) => {
			const $c = $(elm);
			const c = {};
			c.group 		= cat;

			c.$criterion	= $c;
			c.$tickbox		= $c.find(".js-tickbox");
			c.$infoButton	= $c.find(".js-criterion-info-button");
			c.$evidence		= $c.find(".js-criterion-evidence-attached");

			c.itemId 		= parseInt($c.attr("data-criteria-id"));
			c.$marker		= cat.$markers.find(".js-marker[data-criteria-id='"+c.itemId+"']");

			c.required		= parseInt($c.attr("data-required"));
			c.ticked		= parseInt($c.attr('data-completed'));
			c.title			= $c.find(".js-title").text();
			c.content		= $c.find(".js-content").text();
			c.full			= $c.attr("data-full") || c.content;
			c.statement		= $c.attr("data-statement") || "I confirm that we have satisfied the requirements of this criterion.";
			c.evidence		= parseInt($c.attr("data-evidence"));
			c.files			= JSON.parse($c.attr("data-files"));
			c.hasEvidence	= (c.files && Object.keys(c.files).length !== 0);
			c.buttons		= JSON.parse($c.attr("data-buttons")) ?? false;

			const showPopup = e => {
				e.preventDefault();
				e.stopPropagation();

				c.popup = new AccreditationPopup({
					controller: this,
					values: {
						title:       c.title,
						content:     c.full,
						statement:   c.statement,
						buttons:     c.buttons,
						ticked:      c.ticked,
						isReadonly:  this.isReadonly,
						evidence:    c.evidence,
						files: 		 c.files,
						hasEvidence: c.hasEvidence,
						required: 	 c.required
					}
				});

				c.popup.addListener("removeFile", (e, d, f) => {
					// c.popup.removeFile();
					console.log(e, d, f);
					// _this.removeFile(d, f.filename);
				});

				c.popup.addListener("update", e => {
					this.$popupButton = this.$popup.find('.js-finish');

					this.submitting(false, {
						$button: this.$popupButton
					});

					const data = {};
					if(e.hasOwnProperty("files")) data.files = e.files;
					if(e.hasOwnProperty("ticked")) data.ticked = e.ticked;
					c.hasEvidence = (data.files && Object.keys(data.files).length !== 0);

					this.toggle(data, c); // not until progress is active

					/*
					if (!this.isAdmin && this.isApproved === false) {
						this.status = 'unapproved';
						this.isApproved = null;
					}
					*/

					//console.log("requiresCacheClearing: True");
					this.requiresCacheClearing = true;
				});

				c.popup.addListener("close", e => {
					this.checkProgress();
				});
			}

			//c.$criterion.on("click", showPopup);
			c.$criterion.off().on("click", showPopup);

			cat.criteria.push(c)
			criteria.push(c);
		});

		cat.total 			= cat.criteria.length;
		cat.requiredTotal 	= cat.criteria.filter(c => c.required).length;
		cat.bonusTotal 		= cat.total - cat.requiredTotal;

		categories.push(cat);
	});

	categories.forEach(cat => {
		this.updateCategory(cat);
	});
}

/**
 * Save criteria
 *
 * @param criteriaId
 * @param data
 * @returns {boolean}
 */
AccreditationController.prototype.saveCriteria = function(criteriaId, data = {}) {
	if (!criteriaId) return false;

	var postData = {
		itemID: criteriaId,
	};
	if(data.hasOwnProperty("ticked")) postData.completed = data.ticked;
	if(data.hasOwnProperty("files")) postData.files = JSON.stringify(data.files);

	const licenseeHash = nav.getState().nextParams.licensee;
	let queryString = '';
	if(licenseeHash) queryString = `?licensee=${licenseeHash}`;

	// Make AJAX request
	return this.submitData(
		`${this.currentURI}updateCriteria${queryString}`,
		postData,
		{
			$button: this.$popupButton,
		}
	);
}

AccreditationController.prototype.submitData = function(url, data, options = {}) {
	options.$button = options.$button ?? false;
	options.submitting = options.submitting ?? false;

	if (options.submitting && options.$button) {
		// Set submitting state if defined
		this.submitting(false, {
			$button: options.$button
		});
	}

	var request = {};
	var dfd = jQuery.Deferred();
	var promise = dfd.promise();
	request.promise = promise;

	//Load it in
	$.ajax({
		type: 'POST',
		url: url,
		data: data,
		dataType: 'json',
		accepts: {
			json: 'application/json'
		},
	}).then(Igloo.delegate(this, function(result,status,e){
		// var result = $.parseJSON(data);
		request.result = result;
		request.status = "success";
		request.success = 1;

		if (options.onComplete) {
			options.onComplete(result, request.success, e);
		}

		if (options.$button && !this.blockSubmitting) {
			this.submitting(true, options);
		}

		dfd.resolve(request);
	}),Igloo.delegate(this, function(result,status,e){
		request.result  = result;
		request.status  = "error";
		request.success = 0;

		if (options.onComplete) {
			options.onComplete(result, request.success, e);
		}

		dfd.resolve(request);
	}));

	return request.promise;
}

/**
 * Submitting upload state
 *
 * @param done
 */
AccreditationController.prototype.submitting = function(done, options = {}) {
	options.$button = options.$button ?? false;

	if (!options.$button) {
		return true;
	}

	const $button = options.$button;
	if ($button.length) {
		if (!done) {
			$button.prop('disabled', true);
			$button.removeClass('hidden');
			const submittingText = $button.attr("data-submitting") ?? "Submitting...";
			const text = $button.attr("data-text");
			if (!text) $button.attr("data-text", $button.text());
			$button.text(submittingText);
		} else {
			setTimeout( () => {
				const text = $button.attr('data-submitted') ?? $button.attr('data-text');
				$button.text(text);
				$button.prop('disabled', false);
			}, 400);
		}
	}
}

/**
 * Toggle evidence checkbox
 *
 * @param data
 * @param criteria
 */
AccreditationController.prototype.toggle = function(data, criteria){
	Object.assign(criteria, data); // Merge properties of data into criteria object (which at this point are just ticked or checked)

	this.saveCriteria(criteria.itemId, data); // Send data via ajax

	// Don't wait, update frontend html straight away
	criteria.$tickbox.prop('checked', criteria.ticked ? "checked" : false);
	this.updateCategory(criteria.group);
}

/**
 * Update category
 *
 * @param cat
 */
AccreditationController.prototype.updateCategory = function(cat){

	cat.$wrapper.toggleClass("has-count",cat.count > 0);
	cat.$wrapper.toggleClass("has-manditory-count",cat.requiredCount > 0);
	cat.$wrapper.toggleClass("has-bonus-count",cat.bonusCount > 0);

	cat.count 			= cat.criteria.filter(c => c.ticked).length;
	cat.requiredCount 	= cat.criteria.filter(c => c.required && c.ticked).length;
	cat.bonusCount 		= cat.count - cat.requiredCount;
	cat.complete 		= cat.requiredCount >= cat.requiredTotal;

	cat.$total.text(cat.requiredTotal);
	cat.$totalBonus.text(cat.bonusTotal);

	cat.$count.text(cat.requiredCount);
	cat.$countBonus.text(cat.bonusCount);

	cat.$bonusItems.toggle(cat.bonusTotal > 0);

	// Mark completed
	let requiredCounter = 0;
	let bonusCounter = 0;
	cat.criteria.forEach(c => {
		if (c.required) {
			requiredCounter++;
			c.$marker.toggleClass("complete", requiredCounter <= cat.requiredCount);
		} else {
			bonusCounter++;
			c.$marker.toggleClass("complete", bonusCounter <= cat.bonusCount);
		}

		const originalClass = c.$infoButton.attr('data-class');
		const completedClass = c.$infoButton.attr('data-completed-class');
		if (c.ticked) {
			c.$infoButton.removeClass(originalClass).addClass(completedClass);
		} else {
			c.$infoButton.removeClass(completedClass).addClass(originalClass);
		}

		c.$evidence.toggleClass('hide', !c.hasEvidence);
	});
}

/**
 * Get criterion
 *
 * @param criteriaId
 * @returns {*[]}
 */
AccreditationController.prototype.getCriterion = function(criteriaId) {
	return this.criteria.filter(e => e.itemID === criteriaId);
}

/**
 * Progress: Check
 *
 */
AccreditationController.prototype.checkProgress = function(instant) {

	// Render approved template
	if(this.isApproved) {
		this.renderTemplate('approved');
		this.renderTemplate('badge-approved', this.$progress);
		return;
	}

	// Only check criteria total/complete if this.criteria is set.
	if (this.criteria) {
		this.criteriaTotal = this.criteria.filter(c => c.required).length;
		this.criteriaComplete = this.criteria.filter(c => c.ticked && c.required).length;
		//console.log("total",this.criteriaTotal,"completed",this.criteriaComplete);
	}

	console.log(this.criteriaComplete, this.criteriaTotal);

	this.progress   = Math.round( 100 * this.criteriaComplete / this.criteriaTotal );
	this.isComplete = (100 === this.progress);
	//console.log(this.progress, this.previousProgress);

	// We're complete, show the result instantly! This allows our progress to run independently.
	/*
	console.log(
		'is disabled?', this.isDisabled,
		'is complete?', this.isComplete,
		'is approved?', this.isApproved,
		'is making changes?', this.isMakingChanges
	);
	*/

	if (this.isDisabled) {
		this.renderTemplate('cancelled');
	} else if (this.isApproved === true) {
		this.renderTemplate('approved');
	} else if (this.isApproved === false) {
		this.renderTemplate('unapproved');
	} else if (this.isPending) {
		this.renderTemplate('pending');
	} else if (!this.isDisabled && this.isComplete && !this.isMakingChanges) {
		this.renderTemplate('submit');
	} else {
		this.renderTemplate('default');
	}

	if(this.isApproved === false && this.isComplete) {
		this.$submitResults.show();
	} else {
		this.$submitResults.hide();
	}

	// Hide criteria when disabled
	if (this.isDisabled) {
		this.$crieria.hide();
	}

	// Animate progress
	if (!this.isApproved) {
		this.renderProgress();
		this.apt.change(this.progress);
	}
}

/**
 * Animate progress tracker
 *
 * @param i
 */
AccreditationController.prototype.renderProgress = function(i=false){
	if (i === false) {
		i = this.progress;
	}

	const percent = Math.round(i);
	let progressOffset = Math.round(this.circumference - i / 100 * this.circumference);

	this.$progressRing.css({
		strokeDashoffset: `${progressOffset}%`
	});

	// Update percentage number
	this.$progressLabel.text(`${percent}%`);
}

/**
 * Run progress tracker
 *
 * @returns {Promise<unknown>}
 */
AccreditationController.prototype.runProgress = function(instant) {
	if(this.animating) {
		return false;
	}

	// Set our starting point
	// this.currentProgress = this.previousProgress;

	return new Promise((resolve) => {
		this.animating = true;

		const checkProgress = () => {
			this.renderProgress(this.progress);

			if(this.progress === this.currentProgress || instant) {
				this.animating = false;
				resolve();
				return true
			}
			return false;
		}

		checkProgress();

		setInterval(() =>{
			if(checkProgress()) return;

			if(this.currentProgress < this.progress) this.currentProgress++;
			else 									 this.currentProgress--;

			checkProgress();
		},40);
	});
}

/**
 * Load templates
 *
 * @param templates
 * @returns {*[]}
 */
AccreditationController.prototype.loadTemplates = function(templates) {
	const templatesAll = [];
	for(let template in templates){
		template = templates[template];
		const templateHtml = this.getTemplate(`accreditation/${template}`);
		const compiledHtml = Handlebars.compile(templateHtml);
		if(compiledHtml) templatesAll[template] = compiledHtml;
	}
	return templatesAll;
}

/**
 * Render template
 *
 * @param template
 * @param $element
 */
AccreditationController.prototype.renderTemplate = function(template, $element) {
	if(!$element){
		$element = this.$mainHeader;
	}

	let html = this.templates[template];
	if (!html) {
		html = this.defaultTemplate;
	}

	$element.html(html);
	// this.requiresCacheClearing = true;
	this.setup();
}

AccreditationController.prototype.off = function() {
	this.apt.destroy();

	if (this.requiresCacheClearing) {
		const currentUrl = nav.getState().previousUrl;
		jcache.clearCacheEntry(currentUrl); // clear the cache for this page
	}
}